// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"5064ff36","308":"4042539d","329":"b2ccf9be","672":"0c67854e","706":"0affd8e4","972":"0569d1ca"}[chunkId] + ".chunk.css";
};